/* eslint-disable no-param-reassign */
import {
  Field,
  Picker,
  Popup,
  Dialog,
  Icon,
  Toast,
  Tabbar,
  TabbarItem,
  Form,
  DatetimePicker,
  Search,
  Cell,
  CellGroup,
  Lazyload,
  Swipe,
  SwipeItem,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  ImagePreview,
  Image,
  Switch,
  List,
  Grid,
  GridItem,
  Loading,
  Button,
  Uploader
} from "vant";
import moment from "moment";
import VueRouter from "vue-router";
import PhComponents from "@components";
// import vuevx from "weixin-js-sdk";
import axiosUtil from "@src/utils/axiosoUtil";
import regular from "@src/utils/regular";

export default {
  install: function(Vue) {
    Vue.prototype.$http = axiosUtil;
    Vue.prototype.$api = axiosUtil.api;
    Vue.prototype.$wx = wx;
    Vue.prototype.$regular = regular;
    wx.hideOptionMenu();
    wx.hideAllNonBaseMenuItem();

    moment.updateLocale("en", {
      weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
      weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
      weekdaysMin: "日_一_二_三_四_五_六".split("_")
    });
    Vue.prototype.$moment = moment;
    Vue.mixin({
      mounted: function() {
        this.$emit("done");
      }
    });
    Vue.use(Field);
    Vue.use(Picker);
    Vue.use(Popup);
    Vue.use(Dialog);
    Vue.use(Icon);
    Vue.use(Toast);
    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.use(Form);
    Vue.use(DatetimePicker);
    Vue.use(Search);
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(Swipe);
    Vue.use(SwipeItem);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(ImagePreview);
    Vue.use(Image);
    Vue.use(Switch);
    Vue.use(List);
    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(Lazyload, {
      error: require("@assets/ic_patient.png")
    });
    Vue.use(VueRouter);
    Vue.use(PhComponents);
    Vue.use(Loading);
    Vue.use(Button);
    Vue.use(Uploader);
  }
};
